import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});

Font.register({
  family: 'FontAwesome',
  src: '/fa-solid-900.ttf',
});

export const styles = StyleSheet.create({
  page: {},
  contentWrapper: {
    paddingTop: 20,
    paddingHorizontal: 40,
  },
  title: {
    fontFamily: 'Lato',
    fontSize: 20,
    fontWeight: 900,
    textAlign: 'left',
  },
  icon: {
    fontFamily: 'FontAwesome',
    fontSize: 12,
  },

  locationWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,

    marginTop: 10,
    marginBottom: 10,
  },
  location: {
    color: '#27343d',
    fontSize: 9,
    fontFamily: 'Lato',
    fontWeight: 900,
  },

  description: {
    color: '#27343d',
    fontSize: 9,
    fontFamily: 'Lato',
    fontWeight: 400,
    lineHeight: 1.3,
  },
  image: {
    width: '100%',
    height: 280,
    objectFit: 'cover',

    borderRadius: '4px',

    marginTop: 10,
  },

  imageRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 10,

    width: '100%',
    height: 112,
    borderRadius: '4px',

    marginTop: 10,
  },

  imageLeftWrapper: {
    flex: 1,
    height: 112,
    borderRadius: '4px',
  },
  imageRightWrapper: {
    flex: 1,
    height: 112,
    borderRadius: '4px',
  },
  imageLeft: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',

    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    borderBottomLeftRadius: '0px',
    borderBottomRightRadius: '4px',
  },
  imageRight: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',

    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    borderBottomLeftRadius: '4px',
    borderBottomRightRadius: '0px',
  },

  bottomWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    marginTop: 20,
  },

  stayLabel: {
    color: '#27343d',
    fontSize: 9,
    fontFamily: 'Lato',
    fontWeight: 900,
  },

  buttonWrapper: {
    backgroundColor: 'black',
    color: 'white',
    paddingVertical: 5,
    paddingHorizontal: 20,
    width: 270,
  },
  buttonLink: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 9,
    fontWeight: 900,
    textDecoration: 'none',
  },
});
